import { Controller } from "@hotwired/stimulus"

// Accordion behavior for native <details> elements.
//
// Listens for `toggle` on each item target and closes any other open
// sibling so only one disclosure is open at a time. Mirrors the open
// state onto the wrapper as `data-state="open|closed"` so external
// affordances (like a thin footer chevron that sits outside <details>)
// can react via Tailwind's `group-data-[state=open]:` variants.
//
// Also exposes a `toggle` action so any external clickable element
// (e.g. the chevron footer bar) can flip the nearest
// `[data-accordion-row]` ancestor's <details>.
export default class extends Controller {
  static targets = ["item"]

  itemTargetConnected(item) {
    item.addEventListener("toggle", this.onToggle)
    this.syncState(item)
  }

  itemTargetDisconnected(item) {
    item.removeEventListener("toggle", this.onToggle)
  }

  toggle(event) {
    const row = event.currentTarget.closest("[data-accordion-row]")
    const details = row && row.querySelector("details[data-accordion-target='item']")
    if (details) details.open = !details.open
  }

  onToggle = (event) => {
    const opened = event.target
    this.syncState(opened)
    if (!opened.open) return
    this.itemTargets.forEach((el) => {
      if (el !== opened && el.open) el.open = false
    })
  }

  syncState(item) {
    const row = item.closest("[data-accordion-row]")
    if (!row) return
    row.setAttribute("data-state", item.open ? "open" : "closed")
  }
}
